<template>
  <b-sidebar :id="sidebarId"
    width="400px"
    :visible="visible"
    no-close-on-route-change
    right
    shadow
    @hidden="handleCloseSidebar">
    <template v-if="activeProfile">
      <user-profile :active-user="activeProfile"
        @update-groups="handleUpdateGroups"
        @generate-key="handleGenerateKey"
        @delete-key="handleDeleteKey"
        @change-tacacs-password="handleChangeTacacsPassword"
        @update-ssh-keys="handleUpdateSshKeys" />
    </template>
    <user-api-key-modal ref="apiKeyModal" />
  </b-sidebar>
</template>

<script>
import UserProfile from './UserProfile'
import UserApiKeyModal from './UserApiKeyModal'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserSidebar',

  components: {
    'user-profile': UserProfile,
    'user-api-key-modal': UserApiKeyModal,
  },

  props: {
    sidebarId: {
      type: String,
      required: true,
      default: '',
    },
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    activeUser: {
      type: Object,
      required: false,
      default: () => {
        return null
      },
    },
  },

  data() {
    return {
      isLoading: true,
      showSidebar: false,
      showSuccessMessage: false,
    }
  },

  computed: {
    ...mapState('user', ['account', 'myAccount']),
    activeProfile() {
      if (this.activeUser && this.activeUser.id === this.account.id) {
        return this.account
      } else {
        return this.myAccount
      }
    },
  },

  methods: {
    ...mapActions('user', ['updateUserGroups', 'generateApiKey', 'deleteApiKey', 'changeTacacsPassword', 'updateSshKeys']),
    async handleUpdateGroups(groups) {
      try {
        await this.updateUserGroups({ userId: this.activeUser.id, groups: groups })
        this.$emit('update')
        this.$bvToast.toast('The user profile was updated.', {
          title: 'Profile Update',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          noCloseButton: true,
          toaster: 'b-toaster-top-right',
        })
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}]  There was an issue updating. ${error}`, {
          title: 'Profile Update',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
      }
    },
    handleCloseSidebar() {
      this.showSidebar = false
      this.$emit('close')
    },
    async handleGenerateKey(key) {
      try {
        const result = await this.generateApiKey({ userId: this.activeProfile.id, key: key })
        this.$refs.apiKeyModal.show(result.key)
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}] There was an issue updating. ${error}`, {
          title: 'Profile Update',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
      }
    },
    async handleDeleteKey(keyId) {
      try {
        await this.deleteApiKey({ userId: this.activeUser.id, keyId: keyId })
        this.$bvToast.toast('Key removed.', {
          title: 'Profile Update',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          noCloseButton: true,
          toaster: 'b-toaster-top-right',
        })
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}] There was an issue updating. ${error}`, {
          title: 'Profile Update',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
      }
    },
    async handleChangeTacacsPassword(event) {
      try {
        await this.changeTacacsPassword({
          userId: this.activeUser.id,
          passwordHash: event.passwordHash,
        })

        this.$bvToast.toast('TACACS Password Changed.', {
          title: 'TACACS Password',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          noCloseButton: true,
          toaster: 'b-toaster-top-right',
        })
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}] There was an issue updating. ${error}`, {
          title: 'TACACS Password',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
      }
    },
    async handleUpdateSshKeys(event) {
      try {
        await this.updateSshKeys({
          userId: this.activeUser.id,
          authorizedKeys: event.authorizedKeys,
        })

        this.$bvToast.toast('SSH Keys Updated.', {
          title: 'SSH Keys',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          noCloseButton: true,
          toaster: 'b-toaster-top-right',
        })
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}] There was an issue updating. ${error}`, {
          title: 'SSH Keys',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
      }
    },
  },
}
</script>

<style scoped>
.usersList {
  max-height: calc(85vh - 60px);
}
</style>
